export const LOADING_METRICS = "LOADING_METRICS";
export const GET_METRICS_LIST = "GET_METRICS_LIST";
export const GET_METRICSBYID = "GET_METRICSBYID";
export const REMOVE_METRICS = "REMOVE_METRICS";
export const ADD_METRICS = "ADD_METRICS";
export const UPDATE_METRICS = "UPDATE_METRICS";